import UAParser from 'ua-parser-js'

import brandConfig from 'brandConfig'
import { PRODUCTION } from 'src/constants/app'
import packageJson from '../../../package.json'
import { NAVIGATION_TARGET_BLANK } from '../../constants/externalUrls'
import { EMAIL_TYPE_EXCHANGE_PROVIDERS } from '../../constants/pointsExchange'
import { dateDiffInHours } from '../date.helpers'

const getAppVersion = () => packageJson.version

const parseJson = (input) => {
  return input ? JSON.parse(input) : {}
}

const stringifyJson = (input) => {
  return input ? JSON.stringify(input) : ''
}

const errorLogger = (message) => {
  console.log('### ERROR ###')
  console.error(message)
}

const isRunningTesting = () => {
  return process.env.NODE_ENV === 'test'
}

const isListNotEmpty = (list) => {
  return list?.length > 0
}

const isExistsElementFromList = (list, element) => {
  return list?.includes(element)
}

const isExchangeProviderEmailType = (brandId) => {
  return isExistsElementFromList(EMAIL_TYPE_EXCHANGE_PROVIDERS, brandId)
}

const formatUserDeviceDetails = () => {
  return {
    app_version: `${getAppVersion()}`,
    browser_details: new UAParser().getResult()
  }
}

const isValidHtmlContent = (text) => {
  return text.toLowerCase().includes('!doctype html')
}

const openBlankRedirectPage = (url) => {
  window.open(url, NAVIGATION_TARGET_BLANK)
}

const hotReloadApp = () => {
  window.location.reload(true)
}

const buildDropdownList = (dataKey, label, t) => {
  return Object.keys(dataKey).map((key) => ({
    value: dataKey[key],
    label: t(`${label}.${dataKey[key]}`)
  }))
}

const buildPageTitle = (pageTitle) => {
  return `${pageTitle} | ${brandConfig.name}`
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

const reloadWindow = () => {
  window.location.reload()
}

const prependHttpsIfNotExists = (link) => {
  return link && link.indexOf('://') === -1 ? `https://${link}` : link
}

const openExternalUrl = (url, isSelf = false, noHttps = false) => {
  window.openedPage = window.open(
    isSelf ? url : noHttps ? url : prependHttpsIfNotExists(url),
    isSelf ? '_self' : '_blank'
  )
}

const closeWindow = () => {
  if (window.openedPage) {
    window.openedPage.close()
  }
}

const isProduction = () => {
  return process.env.REACT_APP_ENV === PRODUCTION
}

const copyToClipBoard = async (text) => {
  if (
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function'
  ) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      console.warn('navigator.clipboard failed, falling back', err)
    }
  }
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()

    const success = document.execCommand('copy')
    document.body.removeChild(textarea)

    if (!success) throw new Error('Fallback copy failed')
    return true
  } catch (err) {
    console.error('Both clipboard methods failed:', err)
    return false
  }
}

const shouldShowWalletNotification = (insertedAt) => {
  if (!insertedAt) {
    return false
  }
  return dateDiffInHours(insertedAt) >= 1
}

export {
  buildDropdownList,
  buildPageTitle,
  closeWindow,
  errorLogger,
  formatUserDeviceDetails,
  getAppVersion,
  hotReloadApp,
  isExchangeProviderEmailType,
  isExistsElementFromList,
  isListNotEmpty,
  isProduction,
  isRunningTesting,
  isValidHtmlContent,
  openBlankRedirectPage,
  openExternalUrl,
  parseJson,
  reloadWindow,
  scrollToTop,
  stringifyJson,
  copyToClipBoard,
  shouldShowWalletNotification
}
